import { getDir } from "@/i18n/translations";

export const setDocumentMeta = ({ lang, title, description }) => {
  document.title = title;
  document.documentElement.lang = lang;
  document.documentElement.dir = getDir(lang);

  let descriptionTag = document.querySelector('meta[name="description"]');
  if (!descriptionTag) {
    descriptionTag = document.createElement("meta");
    descriptionTag.setAttribute("name", "description");
    document.head.appendChild(descriptionTag);
  }
  descriptionTag.setAttribute("content", description);
};
